module.exports = __webpack_public_path__ + "img/37.70b994c1.svg";